import { DynamicForm, FieldVariant } from '../../../../components/form-builder/form-builder.types';
import { RefTypeRepository } from '../../../../store/ref-type-state/ref-type-state.repository';

interface getRefTypeFormObjectProps {
  store: RefTypeRepository;
}

export const getRefTypeFormObject = ({ store }: getRefTypeFormObjectProps): DynamicForm => {
  return {
    title: 'settings.refType.title',
    description: '',
    isHeaderHidden: true,
    orientation: 'vertical',
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [
              {
                label: 'settings.refType.form.id.label',
                variant: FieldVariant.TEXT,
                isRequired: true,
                props: {
                  value: store.getNestedObservable<string>('dto', 'id'),
                  onChange: (value: string) => store.setNested('dto', 'id', value),
                },
              },
              {
                label: 'settings.refType.form.description.label',
                variant: FieldVariant.TEXT,
                isRequired: true,
                props: {
                  value: store.getNestedObservable<string>('dto', 'description'),
                  onChange: (value: string) => store.setNested('dto', 'description', value),
                },
              },
            ],
          },
        ],
      },
    ],
  };
};
